module.exports = __webpack_public_path__ + "media/images/logo/logo_header_text-99fd1ecd4395eef0ec3b4f7971fd3ce3.jpg";